var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMapPin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.2502 26.4891C20.934 27.8789 19.5274 29.1434 18.1208 30.2646C17.6274 30.6573 17.1688 31.0047 16.7555 31.3031C16.5036 31.4852 16.3202 31.6118 16.2156 31.6816C15.7816 31.9709 15.2158 31.9709 14.7831 31.6816C14.6798 31.6118 14.4951 31.4852 14.2432 31.3031C13.8299 31.0047 13.3713 30.6573 12.8779 30.2646C11.4713 29.1447 10.0647 27.8789 8.74846 26.4891C4.90962 22.4371 2.58204 18.1694 2.58204 13.8139C2.58204 6.68007 8.36483 0.897278 15.4987 0.897278C22.6326 0.897278 28.4154 6.68007 28.4154 13.8139C28.4154 18.1694 26.0878 22.4371 22.249 26.4891H22.2502ZM16.5114 28.2432C17.8289 27.1943 19.1477 26.0073 20.3747 24.7117C23.8015 21.0938 25.8333 17.3699 25.8333 13.8139C25.8333 8.10736 21.2066 3.48061 15.5 3.48061C9.79341 3.48061 5.16666 8.10736 5.16666 13.8139C5.16666 17.3699 7.19846 21.0938 10.6252 24.7117C11.8523 26.0073 13.1698 27.193 14.4886 28.2432C14.8477 28.5299 15.1874 28.7895 15.5 29.0207C15.8126 28.7895 16.1523 28.5299 16.5114 28.2432V28.2432ZM15.5 18.9806C12.6467 18.9806 10.3333 16.6672 10.3333 13.8139C10.3333 10.9607 12.6467 8.64728 15.5 8.64728C18.3533 8.64728 20.6667 10.9607 20.6667 13.8139C20.6667 16.6672 18.3533 18.9806 15.5 18.9806ZM15.5 16.3973C16.9273 16.3973 18.0833 15.2412 18.0833 13.8139C18.0833 12.3867 16.9273 11.2306 15.5 11.2306C14.0727 11.2306 12.9167 12.3867 12.9167 13.8139C12.9167 15.2412 14.0727 16.3973 15.5 16.3973Z",
    fill: "#2C3439"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white",
    transform: "translate(0 0.897278)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPin);
export default __webpack_public_path__ + "static/media/map-pin.9d7d54c47d68e9881a6f43b1cd04cad2.svg";
export { ForwardRef as ReactComponent };